import { motion } from "framer-motion";
import Hero3D from "@/components/landing/Hero3D";

const lines = ["PROJECTS BUILT", "MY WAY.", "MADE TO EVOLVE."];

const lineVariants = {
  hidden: { y: "115%" },
  show: (i) => ({
    y: "0%",
    transition: { delay: 0.25 + i * 0.14, duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Hero({ onRequestAccess }) {
  return (
    <section className="relative flex min-h-[calc(100dvh-4rem-env(safe-area-inset-top))] w-full items-center overflow-hidden md:h-screen md:min-h-0" data-testid="hero-section">
      <Hero3D />
      <div className="pointer-events-none absolute inset-0 z-[1] bg-[linear-gradient(180deg,rgba(2,4,12,.68),rgba(2,4,12,.58)_55%,rgba(2,4,12,.72))] sm:bg-[linear-gradient(90deg,rgba(2,4,12,.94)_0%,rgba(2,4,12,.74)_42%,rgba(2,4,12,.18)_76%,transparent_100%)] lg:bg-[linear-gradient(90deg,rgba(2,4,12,.88)_0%,rgba(2,4,12,.58)_40%,rgba(2,4,12,.10)_72%,transparent_100%)]" />
      <div className="hero-scanline absolute left-0 right-0 h-px bg-[#00FF66]/10 z-[1] pointer-events-none" />
      <div className="relative z-10 px-6 sm:px-12 lg:px-24 max-w-5xl pointer-events-none">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.8 }}
          className="text-xs uppercase tracking-[0.4em] text-[#00F0FF] mb-8"
          data-testid="hero-eyebrow"
        >
          Raava // Built by BaTzEnMoDz
        </motion.p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] font-900" style={{ fontWeight: 900 }}>
          {lines.map((line, i) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                className={`${i === 1 ? "raava-title-gradient raava-glow" : "block text-[#F4F4F5]"}`}
                custom={i}
                variants={lineVariants}
                initial="hidden"
                animate="show"
                data-testid={`hero-line-${i}`}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          className="mt-8 max-w-md text-base text-[#D7DCE5] leading-relaxed"
          data-testid="hero-subtext"
        >
          One connected home for my PC tools, PS3 mod menus, RTM projects and
          everything I build next — created from my own ideas and refined in real use.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.7 }}
          className="mt-12 flex flex-wrap gap-4 pointer-events-auto"
        >
          <button
            onClick={onRequestAccess}
            className="px-8 py-4 bg-[#147DFF] text-white text-xs font-medium uppercase tracking-[0.25em] hover:bg-white hover:text-[#030303] transition-colors duration-300 shadow-[0_0_34px_rgba(20,125,255,.28)]"
            data-testid="hero-cta-access"
          >
            Request Access Key
          </button>
          <a
            href="#manifest"
            className="px-8 py-4 border border-[#222222] text-[#F4F4F5] text-xs uppercase tracking-[0.25em] hover:border-[#00FF66]/60 hover:text-[#00FF66] transition-colors duration-300"
            data-testid="hero-cta-manifest"
          >
            Explore My Work
          </a>
        </motion.div>
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6 }}
        className="absolute bottom-8 left-6 sm:left-12 lg:left-24 z-10 flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]"
        data-testid="hero-scroll-hint"
      >
        <span className="w-8 h-px bg-[#36B9FF]" /> Scroll — discover Raava
      </motion.div>
    </section>
  );
}
